<template>
  <!-- 价格竞争力 -->
  <el-form ref="form" :model="form" label-position="top">
    <div class="form_container">
      <!-- 价格竞争力 -->
      <el-form-item label="" prop="priceCompetitiveness">
        <el-input
          v-model="form.priceCompetitiveness"
          type="textarea"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
    </div>
  </el-form>
</template>

<script>
import { addOrUpdateCustomerInfoApi } from "@/api/saleTaskCollection";

export default {
  data() {
    return {
      queryParams: {},
      form: this.getForm()
    };
  },
  methods: {
    async init(data, queryParams = {}) {
      this.form = this.getForm(data || {});
      this.queryParams = { ...queryParams };
    },
    // 获取表单数据
    getForm(data = {}) {
      return {
        id: data.id || "",
        priceCompetitiveness: data.priceCompetitiveness || ""
      };
    },
    // 保存
    async handleSave(callBack) {
      this.$refs.form.validate(async valid => {
        if (!valid) {
          return;
        }
        try {
          const submitData = JSON.parse(
            JSON.stringify({ ...this.queryParams, ...this.form })
          );
          const res = await addOrUpdateCustomerInfoApi(submitData);
          if (res.status == 0) {
            this.$DonMessage.success("操作成功！");
            this.form.id = res.data.id;
            this.$emit("setId", res.data.id);
            callBack();
          } else {
            this.$DonMessage.error(res.message);
          }
        } catch (error) {
          console.error(error);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.form_container {
  margin-top: 34px;
  padding: 0 18px 0 50px;
  ::v-deep {
    .el-input {
      width: 200px;
    }
  }
  .input_number_box {
    width: 200px;
  }
  .number_input {
    ::v-deep {
      .el-input__inner {
        text-align: left;
        border-radius: 4px 0 0 4px;
      }
      .el-input {
        width: 100%;
      }
    }
  }
  .number_input_append {
    color: #666666;
    background: #efefef;
    border-radius: 0 4px 4px 0;
    display: inline-block;
    height: 40px;
    line-height: 40px;
    padding: 0 15px;
    text-align: center;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    border: 1px solid #dcdfe6;
    border-left: none;
    box-sizing: border-box;
  }
}
</style>
